<template>
    <textarea
        class="def-textarea"
        :class="{ 'def-textarea__invalid': !isValid}"
        :placeholder="placeholder"
        :name="name"
        :required="required"
        :value="saveValue"
        @input="handlerInput"
        @invalid.prevent="handlerInvalid"
        @blur="handlerBlur"
        @focus="handlerFocus"
    />
</template>

<script>
export default {
    name: 'DefTextarea',
    selector: '.def-textarea',
    props: ['placeholder', 'name', 'value', 'required'],
    data() {
        return {
            isValid: true,
            isFocus: false,
            saveValue: this.value,
        }
    },
    methods: {
        handlerInput(e) {
            // console.log(e.target.value);
            this.saveValue = e.target.value;
            this.$emit('input', e);
        },
        handlerInvalid(e) {
            console.log(this.required);
            if (this.required) {
                console.log('invalid!!!');
                this.isValid = false;
            }

            this.$emit('invalid', e);
        },
        handlerBlur(e) {
            const target = e.target;
            this.saveValue = target.value;
            if (target.checkValidity() && this.required) {
                this.isValid = true;
            }
            this.isFocus = false;
            this.$emit('blur', e);
        },
        handlerFocus(e) {
            this.isFocus = true;
            this.$emit('focus', e);
        }
    },
    watch: {
        value(newValue) {
            this.saveValue = newValue;
        }
    },
}
</script>

<style lang="scss" scoped>
.def-textarea{
    border-radius: 8px;
    border: 1px solid #A9A9A9;
    //background: #FFF;
    ::placeholder{
        color: #A9A9A9;
        //font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }
    &__invalid{
        border-color: var(--background-red);
    }
}
</style>